import { capitaliseAllWords } from '@idu-nightlife/nightlife-utils';

/** A grant's on-screen role name (FR-038a): the venue's name, else the title-cased legacy role. */
export const roleLabel = (
  grant: { role?: string | null; roleName?: string | null },
  fallback = '',
): string => grant.roleName ?? (grant.role ? capitaliseAllWords(grant.role) : fallback);
